/** Tentativas de contacto tab (Por Contactar → Não Atendido). */

import type { TentativasContactoData } from '../api/cccApi';
import { normalizeProspeccaoSubstage } from './prospeccaoWorkspace';
import { normalizeWorkspaceSubstage } from './recuperacaoWorkspace';

export const NAO_ATENDIDO_SUBSTAGE = 'por-contactar-nao-atendido';

export const NAO_ATENDIDO_TAB_SUBSTAGES = new Set<string>([
  NAO_ATENDIDO_SUBSTAGE,
  'agendamentos-remarcacao',
]);

export const TENTATIVAS_CONTACTO_WARNING_TEXT =
  'Registe pelo menos uma tentativa de contacto antes de mudar de marcação';

export function isNaoAtendidoSubstage(substage: string): boolean {
  return NAO_ATENDIDO_TAB_SUBSTAGES.has(normalizeWorkspaceSubstage(substage));
}

export function isProspeccaoNaoAtendidoSubstage(substage: string): boolean {
  return NAO_ATENDIDO_TAB_SUBSTAGES.has(normalizeProspeccaoSubstage(substage));
}

export function isTentativasContactoIncomplete(data?: TentativasContactoData | null): boolean {
  const items = data?.items;
  return !items || items.length === 0;
}

export const todayIsoDate = (): string => {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

export const nowTimeHm = (): string => {
  const d = new Date();
  const h = String(d.getHours()).padStart(2, '0');
  const min = String(d.getMinutes()).padStart(2, '0');
  return `${h}:${min}`;
};

export const formatAttemptDateTime = (date?: string | null, time?: string | null): string => {
  if (!date) return '—';
  const [y, m, d] = date.split('-');
  const datePart = d && m && y ? `${d}/${m}/${y}` : date;
  if (!time) return datePart;
  return `${datePart} às ${time}`;
};
